const endpoints = {
  updateEscalationFollowUp:
    "/v1/auth/agency/employee/escalations/follow-up/update",
  followUpEscalation: "/v1/auth/agency/employee/escalations/follow-up",
};

export default endpoints;
